import React from 'react';

export enum BUTTON_MODE {
	ROUNDED = 'ROUNDED',
	TEXT = 'TEXT',
	LIGHT = 'LIGHT'
}

type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
	mode?: BUTTON_MODE,
	className?: string,
	children?: React.ReactNode,
}

export function Button ({mode = BUTTON_MODE.ROUNDED, className = '', children, ...props}: ButtonProps) {

	const classBtn = {
		[BUTTON_MODE.ROUNDED] : 'bg-cyan text-xl leading-6 min-h-[46px] h-[46px] border rounded-3xl text-white border-cyan-dark',
		[BUTTON_MODE.TEXT] : 'text-cyan',
		[BUTTON_MODE.LIGHT] : 'bg-white text-xl leading-6 min-h-[46px] h-[46px] border rounded-3xl border-cyan text-cyan',
	}

	return (
		<button className={`${classBtn[mode]} text-center font-semibold ${className}`} {...props}>
			{children}
		</button>
	)
}
